// extracted by mini-css-extract-plugin
export default {"root":"Products-root_AnoS9"};